<template>
    <svg :width="props.width" :height="props.height" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.8301 14.2875L11.9701 15.4275L14.2501 13.1475"
        :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M9.11995 8.1525C9.04495 8.145 8.95495 8.145 8.87245 8.1525C7.08745 8.0925 5.66995 6.63 5.66995 4.83C5.66245 2.9925 7.15495 1.5 8.99245 1.5C10.83 1.5 12.3225 2.9925 12.3225 4.83C12.3225 6.63 10.8974 8.0925 9.11995 8.1525Z"
        :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M8.99253 16.3573C7.62753 16.3573 6.27003 16.0123 5.23503 15.3223C3.42003 14.1073 3.42003 12.1273 5.23503 10.9198C7.29753 9.53977 10.68 9.53977 12.7425 10.9198"
        :stroke="props.color" stroke-width="1.5" stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
  color: {
    type: String,
    default: 'rgb(var(--locumate-primary-color-dark))',
  },
  width: {
    type: Number,
    default: 18,
  },
  height: {
    type: Number,
    default: 18,
  },
});
</script>